var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content draggable-content"},[_c('router-view'),_c('MsgBox',{staticClass:"msgBox"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }